import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import Select from "react-select";
import Loader from "../../loaders/Loader";
import { CSVLink } from 'react-csv';
import {logOut} from "../../../redux/dataUploader/dataSlice";

const AffisePopup = ({
        closeAffisePopup, 
        selectStyles,
        filterParams,
        selectedANAccount,
        userId,
        offerSortColumn,
        offerSortDirection,
        setShowConfirmationPopup,
        setConfirmationPopupText,
        totalRows,
        separator = ',',
        enclosingCharacter = '"',
        filename
    }) => {

    const paymentTypesOptions = [
        {value: 'fixed', label: 'CPA(fixed)'}, 
        {value: 'percent', label: 'CPS(percent)'}, 
        {value: 'mixed', label: 'RPS/CPA(mixed)'}, 
        {value: 'first_cpa', label: 'FTD/FTP (CPA)'}, 
        {value: 'first_cps', label: 'FTD/FTP (RevShare)'}
    ];
    const privacyLevelsOptions = [
        {value: 'protected', label: 'Pre-moderation'},
        {value: 'private', label: 'Private'},
        {value: 'public', label: 'Public'}
    ];
    const redirecTypesOptions = [
        {value: 'http302', label: 'HTTP 302 redirect'},
        {value: 'http302hidden', label: 'HTTP 302 redirect with hidden referrer'},
        {value: 'js', label: 'JS meta-redirect'},
        {value: 'meta', label: 'HTTP meta-redirect'}
    ];
    const statusesOptions = [
        {value: 'active', label: 'Active'},
        {value: 'stopped', label: 'Disabled'},
        {value: 'suspended', label: 'Paused '}
    ];
    const topOffersOptions = ['NO', 'YES'];
    const currenciesCodes = [
        'USD', 'EUR', 'GBP', 'JPY', 'AUD', 'CAD', 'CHF', 'CNY', 'SEK', 'NZD',
        'HUF', 'PLN', 'NOK', 'BRL', 'INR', 'RUB', 'ZAR', 'SGD', 'HKD', 'KRW',
        'MXN', 'TRY', 'ILS', 'SAR', 'AED', 'DKK', 'THB', 'MYR', 'IDR', 'CZK',
        'RON', 'CLP', 'COP', 'ARS', 'VND', 'PKR', 'EGP', 'NGN', 'KWD', 'BHD', 'UAH'
        ];
    const [limit, setLimit] = useState(100);
    const [limitWarning, setLimitWarning] = useState(false);
    const [paymentType, setPaymentType] = useState(paymentTypesOptions[0].value);
    const [privacyLevel, setPrivacyLevel] = useState(privacyLevelsOptions[0].value);
    const [redirectType, setRedirectType] = useState(redirecTypesOptions[0].value);
    const [status, setStatus] = useState(statusesOptions[0].value);
    const [topOffer, setTopOffer] = useState(topOffersOptions[0]);
    const [notes, setNotes] = useState('');
    const [payouts, setPayouts] = useState('');
    const [ourRevenue, setOurRevenue] = useState('');
    const [currency, setCurrency] = useState('USD');
    const [kpi, setKpi] = useState('');
    const [timeZone, setTimeZone] = useState('UTC (UTC+00:00)');
    const [enabledAffiliates, setEnabledAffiliates] = useState('');
    const [disabledAffiliates, setDisabledAffiliates] = useState('');
    const [affiseTags, setAffiseTags] = useState('');

    const [affiseData, setAffiseData] = useState([]);
    const [headersData, setHeadersData] = useState([]);
    const [dataReady, setDataReady] = useState(false);

    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const checkSession = (status) => {
        if(status === 401) {
            dispatch(logOut());
        }
    }

    useEffect(() => {
        setLimit(totalRows);
        if(totalRows > 1000) {
            setLimit(1000);
            setLimitWarning(true);
        }
    }, []);

    const onSubmit = async () => {
        const token = localStorage.getItem("auth_token");

        let allFileters = {};
        if (filterParams) {
            allFileters = {...filterParams};
        }

        const urlColumnsToSearchParam = {
            global_join_by: "AND"
        };

        if (filterParams) {
            Object.keys(allFileters).forEach(key => {
                const { operator, value } = allFileters[key];
              
                urlColumnsToSearchParam[key] = {
                    operator: operator,
                    value: [value],
                    join_by: "AND"
                };
            });
        }

        const requestBody = {
            'where': JSON.stringify(urlColumnsToSearchParam),
            'offerSortColumn': offerSortColumn,
            'offerSortDirection': offerSortDirection,
            'limit': Number(limit),
            'payment_type': paymentType,
            'privacy_level': privacyLevel,
            'redirect_type': redirectType,
            'status': status,
            'top_offer': topOffer,
            'payouts': Number(payouts),
            'our_revenue': Number(ourRevenue),
            'currency': currency,
            'time_zone': timeZone,
        }

        if (notes) requestBody.notes = notes;
        if (kpi) requestBody.kpi = kpi;
        if (enabledAffiliates) requestBody.enabled_affiliates = enabledAffiliates;
        if (disabledAffiliates) requestBody.disabled_affiliates = disabledAffiliates;
        if (affiseTags) requestBody.tags = affiseTags;        
        
        try {
            setLoading(true);
            const response = await fetch(`${localStorage.getItem("apiUrl")}api/affiliate-network/download-offers-for-affise/${selectedANAccount}/${userId}`, {

                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(requestBody)
            });

            checkSession(response.status);

            if (!response.ok) {
                throw new Error('Error fetching data');
            }

            const data = await response.text();
            const rows = data.split('\n').map(row => row.trim());
            const headers = rows[0].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(header => header.trim().replace(/['"]+/g, ''));
            const parsedData = rows.slice(1).map(row => {
                const values = row.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(value => {
                    value = value.trim();
                    if (value.startsWith('"') && value.endsWith('"')) {
                        value = value.slice(1, -1);
                    }
                    return value;
                });
                const obj = {};
                headers.forEach((header, index) => {
                    obj[header] = values[index] || "";
                });
                return obj;
            });

            const headersDataFromEndpoint = headers.map(header => ({
                label: header,
                key: header
            }));

            setAffiseData(parsedData);
            setHeadersData(headersDataFromEndpoint);
            setDataReady(true);
        } catch (error) {
            console.error('Error:', error);
            setConfirmationPopupText("Something went wrong")
            setShowConfirmationPopup(true)
        } finally {
            setLimit(1000);
            setPaymentType(paymentTypesOptions[0].value);
            setPrivacyLevel(privacyLevelsOptions[0].value);
            setRedirectType(redirecTypesOptions[0].value);
            setStatus(statusesOptions[0].value);
            setTopOffer(topOffersOptions[0]);
            setNotes('');
            setPayouts('');
            setOurRevenue('');
            setCurrency('USD');
            setKpi('');
            setTimeZone('UTC (UTC+00:00)');
            setEnabledAffiliates('');
            setDisabledAffiliates('');
            setAffiseTags('');

            setLoading(false);
        }
    };

    const handleChangeLimitsValidation = (value) => {
        if(value > 1000) {
            setLimitWarning(true);
            setLimit(1000);
        } else {
            setLimitWarning(false);
            setLimit(value);
        }
    }

    const handleCHangeEnabledAffiliates = (value) => {
        setEnabledAffiliates(value);
    }

    const handleCHangeDisabledAffiliates = (value) => {
        setDisabledAffiliates(value);
    }

    const handleCHangeAffiseTags = (value) => {
        setAffiseTags(value);
    }

    return (
        <div className='add-item-popup-container voluum-popup-container'>
            <div className="add-item-popup-block">
                { loading ? <div className='loading-wrap-center'><Loader/></div> : (
                    <div className='form-wrap'>
                        <div className="title-wrap">
                            <h1>Affise Integration</h1>
                            <div className="close-btn" onClick={closeAffisePopup}>
                                <img src={`${process.env.PUBLIC_URL}/images/close-btn.svg`} alt="close popup"/>
                            </div>
                        </div>
                        <div className="form-flex-container">
                            <form
                                    className="file-upload affise-form"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        onSubmit();
                                    }}
                                >
                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offers-limit" className="field-label">Limit</label>
                                    <input
                                        type="number"
                                        id='offers-limit'
                                        name='offers-limit'
                                        styles={selectStyles}
                                        placeholder='Enter limit'
                                        value={limit}
                                        onChange={(e) => handleChangeLimitsValidation(e.target.value)}></input>
                                    {limitWarning && (<p className="warning">Total offers: {totalRows}. Maximum ofers per one request: 1000</p>)}
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offer-limit">Payment Type</label>
                                    <Select
                                        className={"affise-select"}
                                        styles={selectStyles}
                                        options={paymentTypesOptions.map(item => ({value: item.value, label: item.label}))}
                                        isSearchable={true}
                                        defaultValue={{value: paymentTypesOptions[0].value, label: paymentTypesOptions[0].label}}
                                        name={"payment_types"}
                                        placeholder={"Payment Types"}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        onChange={(option) => setPaymentType(option.value)}
                                    />
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offer-limit">Privacy Level</label>
                                    <Select
                                        className={"affise-select"}
                                        styles={selectStyles}
                                        options={privacyLevelsOptions.map(item => ({value: item.value, label: item.label}))}
                                        isSearchable={true}
                                        defaultValue={{value: privacyLevelsOptions[0].value, label: privacyLevelsOptions[0].label}}
                                        name={"privacy_level"}
                                        placeholder={"Privacy Level"}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        onChange={(option) => setPrivacyLevel(option.value)}
                                    />
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offer-limit">Redirect Type</label>
                                    <Select
                                        className={"affise-select"}
                                        styles={selectStyles}
                                        options={redirecTypesOptions.map(item => ({value: item.value, label: item.label}))}
                                        isSearchable={true}
                                        defaultValue={{value: redirecTypesOptions[0].value, label: redirecTypesOptions[0].label}}
                                        name={"redirect_type"}
                                        placeholder={"Redirect Type"}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        onChange={(option) => setRedirectType(option.value)}
                                    />
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offer-limit">Status</label>
                                    <Select
                                        className={"affise-select"}
                                        styles={selectStyles}
                                        options={statusesOptions.map(item => ({value: item.value, label: item.label}))}
                                        isSearchable={true}
                                        defaultValue={{value: statusesOptions[0].value, label: statusesOptions[0].label}}
                                        name={"status"}
                                        placeholder={"Status"}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        onChange={(option) => setStatus(option.value)}
                                    />
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offers-notes" className="field-label">Notes</label>
                                    <input
                                        type="text"
                                        id='offers-notes'
                                        name='offers-Notes'
                                        styles={selectStyles}
                                        placeholder='Special offer notes'
                                        value={notes}
                                        onChange={(e) => setNotes(e.target.value)}></input>
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offer-limit">Top Offer</label>
                                    <Select
                                        className={"affise-select"}
                                        styles={selectStyles}
                                        options={topOffersOptions.map(item => ({value: item, label: item}))}
                                        isSearchable={true}
                                        defaultValue={{value: topOffersOptions[0], label: topOffersOptions[0]}}
                                        name={"top_offer"}
                                        placeholder={"Top Offer"}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        onChange={(option) => setTopOffer(option.value)}
                                    />
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offers-payouts" className="field-label">Payouts</label>
                                    <input
                                        type="number"
                                        id='offers-payouts'
                                        name='offers-payouts'
                                        styles={selectStyles}
                                        placeholder='Enter Number'
                                        value={payouts}
                                        onChange={(e) => setPayouts(e.target.value)}></input>
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offers-our_revenue" className="field-label">Our Revenue</label>
                                    <input
                                        type="number"
                                        id='offers-our_revenue'
                                        name='offers-our_revenue'
                                        styles={selectStyles}
                                        placeholder='Enter number'
                                        value={ourRevenue}
                                        onChange={(e) => setOurRevenue(e.target.value)}></input>
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offers-currency">Currency</label>
                                    <Select
                                        className={"affise-select"}
                                        styles={selectStyles}
                                        options={currenciesCodes.map(item => ({value: item, label: item}))}
                                        isSearchable={true}
                                        defaultValue={{value: currenciesCodes[0], label: currenciesCodes[0]}}
                                        name={"offers-currency"}
                                        placeholder={"Currency"}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        onChange={(option) => setCurrency(option.value)}
                                    />
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offers-kpi" className="field-label">KPI</label>
                                    <input
                                        type="text"
                                        id='offers-kpi'
                                        name='offers-kpi'
                                        styles={selectStyles}
                                        placeholder='Enter KPI (Install > 100)'
                                        value={kpi}
                                        onChange={(e) => setKpi(e.target.value)}></input>
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offers-tags" className="field-label">Tags</label>
                                    <input
                                        type="text"
                                        id='offers-tags'
                                        name='offers-tags'
                                        styles={selectStyles}
                                        placeholder='Enter Tags separated by space or coma'
                                        value={affiseTags}
                                        onChange={(e) => handleCHangeAffiseTags(e.target.value)}></input>
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offers-enabled_affiliates" className="field-label">Enabled Affiliates</label>
                                    <input
                                        type="text"
                                        id='offers-enabled_affiliates'
                                        name='offers-enabled_affiliates'
                                        styles={selectStyles}
                                        placeholder='Enter IDs separated by space or coma'
                                        value={enabledAffiliates}
                                        onChange={(e) => handleCHangeEnabledAffiliates(e.target.value)}></input>
                                </div>

                                <div className="input-block without-config-item-block">
                                    <label htmlFor="offers-disabled_affiliates" className="field-label">Disabled Affiliates</label>
                                    <input
                                        type="text"
                                        id='offers-disabled_affiliates'
                                        name='offers-disabled_affiliates'
                                        styles={selectStyles}
                                        placeholder='Enter IDs separated by space or coma'
                                        value={disabledAffiliates}
                                        onChange={(e) => handleCHangeDisabledAffiliates(e.target.value)}></input>
                                </div>

                                <div className="form-buttons-block">

                                    <button 
                                        type="submit"
                                        className="blue-btn">
                                        Submit  
                                    </button>
                                    {dataReady && (
                                        <CSVLink
                                            data={affiseData}
                                            filename={filename}
                                            className='blue-btn csv'
                                            target='_blank'
                                            separator={separator}
                                            enclosingCharacter={enclosingCharacter}
                                            headers={headersData}
                                        >
                                            Download Csv
                                        </CSVLink>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                    )
                }
            </div>
        </div>
    )
}

export default AffisePopup;
